/* @jsx h */
import { defineComponent, h } from "vue";

export type SelectWithIconOption = {
  value: string;
  label: string;
};

export type SelectWithIconProps = {
  value: string;
  onChange: (value: string) => void;
  icon: string;
  options: SelectWithIconOption[];
  placeholder?: string;
  class?: string;
  selectClass?: string;
  disabled?: boolean;
};

export const SelectWithIcon = defineComponent<SelectWithIconProps>({
  name: "SelectWithIcon",
  props: ["value", "onChange", "icon", "options", "placeholder", "class", "selectClass", "disabled"],
  setup(props) {
    return () => (
      <div class={`relative inline-flex items-center ${props.class ?? ""}`}>
        {/* Overlay icon — pointer-events-none so it doesn't intercept clicks */}
        <span
          class="material-symbols-outlined absolute left-2.5 top-1/2 -translate-y-1/2 pointer-events-none text-base-content/40 select-none"
          style="font-size: 16px; line-height: 1;"
        >
          {props.icon}
        </span>

        <select
          class={`select select-bordered text-accent pl-8 w-full ${props.selectClass ?? ""}`}
          value={props.value}
          disabled={props.disabled}
          onChange={(e) => props.onChange((e.target as HTMLSelectElement).value)}
        >
          {props.placeholder !== undefined && <option value="">{props.placeholder}</option>}
          {props.options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
    );
  },
});
